export default __webpack_public_path__ + "assets/images/a8b2901081bae879d70297357c3adc8e.png";